import styled from 'styled-components';
import colors from './constants/colors';

const Spinner = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  border-radius: 50%;
  box-shadow: inset 0 0 0 0.25rem ${({ color }) => color || colors.white};
  font-size: 11px;
  height: 3rem;
  position: relative;
  text-indent: -99999em;
  transform: translateZ(0);
  width: 3rem;

  &::before,
  &::after {
    background: ${({ color }) => color || colors.ghostWhite};
    border-radius: 3rem 0 0 3rem;
    box-shadow: 0 0 0 1px ${({ color }) => color || colors.ghostWhite};
    content: '';
    height: 3rem;
    left: 0;
    position: absolute;
    top: 0;
    transform-origin: 1.5rem 1.5rem;
    width: 1.5rem;
  }

  &::before {
    animation: spin 1.25s infinite ease 0.2s;
  }

  &::after {
    animation: spin 1.25s infinite ease;
  }
`;

export default Spinner;
